import { AppLocale } from 'constant';
import { Album } from 'interfaces';

import albumsDataRaw from 'data/albums.json';

const albumsData: Album[] = albumsDataRaw as unknown as Album[];

export const getAlbum = (albumId, isInternational, locale = AppLocale.EN, field: 'name' | 'link' = 'name') => {
  const album = albumsData.filter((album) => album.id === albumId && album.international === isInternational)[0];

  switch (field) {
    case 'name': {
      return locale === AppLocale.EN ? album?.englishName || album.name : album.name;
    }
    case 'link': {
      return `/albums/${album.id}${album.international ? '?international=true' : ''}`;
    }
  }
}

export const getAlbumNumber = (albumId, international) => {
  const albumDetails = albumsData.filter((el) => el.id === albumId && el.international === international)[0];
  const sameTypeAlbum = albumsData.filter((el) => el.international === albumDetails.international && el.typeId === albumDetails.typeId);
  const albumNumberIndex = sameTypeAlbum.findIndex(i => i.id === albumDetails.id);

  return albumNumberIndex + 1;
}
